/* bs-favorites — pinta la página de favoritos con la MISMA card que la home (bs-product-card),
   renderizada en el servidor via /products/{handle}?view=card para tener metafields, precio y
   badges reales. Lee window.BSWishlist (bs-wishlist.js). El corazón viene activo = quitar de
   favoritos (lo gestiona bs-wishlist.js global). Re-pinta al cambiar la wishlist.

   Limpieza: si un handle da 404 (producto borrado/despublicado) se quita del wishlist con
   BSWishlist.prune → el contador del header vuelve a cuadrar con lo que hay de verdad.
   Solo se limpia en 404 real; un error de red (status 0) NO borra (para no perder favoritos). */
(function () {
  'use strict';

  var grid, empty;
  var cleaning = false; // evita re-render en bucle durante la limpieza de handles muertos

  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=card', {
      headers: { Accept: 'text/html' },
    })
      .then(function (r) {
        return r.text().then(function (t) {
          return { status: r.status, html: r.ok ? t : '' };
        });
      })
      .catch(function () {
        return { status: 0, html: '' }; // error de red → status 0 → NO se borra
      });
  }

  function render() {
    if (!grid) return;
    var list = window.BSWishlist && window.BSWishlist.read ? window.BSWishlist.read() : [];

    if (!list.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.setAttribute('aria-busy', 'true');

    Promise.all(
      list.map(function (it) {
        return fetchCard(it.h).then(function (res) {
          return { h: it.h, status: res.status, html: res.html };
        });
      })
    ).then(function (results) {
      var validHtml = [];
      var dead = []; // productos borrados (404) → limpiar del wishlist
      results.forEach(function (res) {
        /* Card válida = 200 + contiene la card + tamaño de card (no una página entera). */
        if (res.html && res.html.length < 20000 && res.html.indexOf('bs-product-card') !== -1) {
          validHtml.push(res.html);
        } else if (res.status === 404) {
          dead.push(res.h);
        }
        /* status 0 (red) u otros: se salta esta vez, pero NO se borra. */
      });

      /* Limpiar handles muertos → el badge del header se recalcula al valor real. */
      if (dead.length && window.BSWishlist && window.BSWishlist.prune) {
        cleaning = true;
        window.BSWishlist.prune(dead);
        cleaning = false;
      }

      grid.innerHTML = validHtml.join('');
      grid.removeAttribute('aria-busy');

      /* Los corazones de las cards vienen en estado "guardado" (son favoritos). */
      grid.querySelectorAll('.wishlist-button').forEach(function (b) {
        b.classList.add('is-wishlist');
        b.setAttribute('aria-pressed', 'true');
      });

      /* Si no quedó ninguna card válida, mostrar el estado vacío. */
      if (!validHtml.length) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
      }
    });
  }

  function init() {
    grid = document.querySelector('[data-bs-fav-grid]');
    empty = document.querySelector('[data-bs-fav-empty]');
    if (!grid) return;
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Al quitar un favorito (el corazón dispara el toggle global de bs-wishlist.js) re-pintamos.
     Ignoramos el evento durante nuestra propia limpieza (cleaning) para no re-pintar en bucle. */
  document.addEventListener('bs:wishlist:change', function () {
    if (cleaning) return;
    render();
  });
  document.addEventListener('shopify:section:load', init);
})();
